import React, { Suspense, useEffect, useState } from "react";
import PageWrapper from "../../components/admin/layouts/PageWrapper/PageWrapper";
import Container from "../../components/admin/layouts/Container/Container";
import { DeliveryMan1 } from "../../assets/images";
import Header, { HeaderLeft, HeaderRight } from "../../components/admin/layouts/Header/Header";
import DefaultHeaderRightCommon from "../../templates/layouts/Headers/_common/DefaultHeaderRight.common";
import Breadcrumb from "../../components/admin/layouts/Breadcrumb/Breadcrumb";
import Subheader, { SubheaderLeft } from "../../components/admin/layouts/Subheader/Subheader";
import classNames from "classnames";
import useRoundedSize from "../../hooks/useRoundedSize";
import getFirstLetter from "../../utils/getFirstLetter";
import { getCompanyById } from "../../services/companyService";
import { logoutFun } from "../../utils/helper";
import { useMsal } from "@azure/msal-react";
import { GetPictureByContext } from "../../services/vizyBilityServices";

const UnderConstructionPage = () => {
  const [companyInfo, setCompanyInfo] = useState({});
  const [companyImg, setCompanyImg] = useState({});
  const { instance, accounts } = useMsal();
  const { roundedCustom } = useRoundedSize("rounded-xl");
  const azureUserInfo = localStorage.getItem("getAzureUserData")
    ? JSON.parse(localStorage.getItem("getAzureUserData") || {})
    : null;

  useEffect(() => {
    GetCompanyInfo();
    GetCompanyImg();
  }, []);

  const GetCompanyInfo = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    getCompanyById(azureUserInfo?.CompanyId, header, instance, accounts)
      .then((res) => {
        setCompanyInfo(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun(instance);
        }
      });
  };

  const GetCompanyImg = () => {
    const header = {
      authorization: `Bearer ${localStorage.getItem("vizy-bility-token")}`,
    };
    const query = `context=Company&contextId=${azureUserInfo?.CompanyId}`;

    GetPictureByContext(query, header, instance, accounts)
      .then((res) => {
        setCompanyImg(res.data);
      })
      .catch((err) => {
        if (err?.status == 401 || err?.statusText == "Unauthorized") {
          logoutFun(instance);
        }
      });
  };

  return (
    <>
      <Header>
        <HeaderLeft>
          <Breadcrumb path="Under Construction" currentPage="" />
        </HeaderLeft>
        <HeaderRight>
          <DefaultHeaderRightCommon />
        </HeaderRight>
      </Header>
      <PageWrapper name="Under Construction">
        <Subheader>
          <SubheaderLeft>
            <div className="flex items-center">
              <div className="mr-[10px]">
                {companyImg?.[0]?.url ? (
                  <img src={companyImg?.[0]?.url} alt="" className="h-12 w-12" />
                ) : (
                  <div
                    className={classNames(
                      "flex aspect-square h-12 w-12 items-center justify-center bg-blue-500/20 text-blue-500",
                      [`${roundedCustom(-2)}`]
                    )}
                  >
                    {companyInfo?.CompanyName && getFirstLetter(companyInfo?.CompanyName)}
                  </div>
                )}
              </div>
              <div>
                <div className="text-lg font-semibold">{companyInfo?.CompanyName}</div>
                <div className="text-sm text-zinc-500">
                  {companyInfo?.Address1} {companyInfo?.Address2}
                </div>
              </div>
            </div>
          </SubheaderLeft>
        </Subheader>

        <Container className="flex h-full items-center justify-center">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 mb-16 flex flex-wrap justify-center gap-4">
              <div className="flex basis-full justify-center">
                <span className="text-5xl font-semibold">Under Construction</span>
              </div>
              <div className="flex basis-full justify-center">
                <span className="text-zinc-500">We are working to publish the page as soon as possible.</span>
              </div>
            </div>
            <div className="col-span-3" />
            <div className="col-span-6 flex justify-center">
              <img src={DeliveryMan1} alt="" className="max-h-[50rem] h-full" />
            </div>
          </div>
        </Container>
      </PageWrapper>
    </>
  );
};

export default UnderConstructionPage;
